import type { FaireProductEntity } from "../../entity_types/product";

export const p_g9mavdvwvq: FaireProductEntity = {
  token: "p_g9mavdvwvq",
  type: "product",
  name: "Aloha Greeting Card",
  brandName: "Lady Pilot Letterpress",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c421dc6e1c3a63abcaeb2060354cf7c8c0286a754133773e539c35c5d2a26613.png",
  priceDollars: 2.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/374258e53c34bd79718a5f4e75179d276af72364b1d3e5f4cb55d5e28f5ec1c6.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
